<template>
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    v-bind="$attrs"
    :class="[color]"
  >
    <div class="container-fluid py-1 px-3">
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleSidebar"
        aria-controls="sidenav-main"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
        <div class="ms-md-auto pe-md-3 d-flex align-items-center">
          <slot name="search"></slot>
        </div>
        <ul class="navbar-nav justify-content-end">
          <slot name="items"></slot>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
//import MaterialInput from "@/components/MaterialInput.vue";
//import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
    };
  },
  props: ["minNav", "color"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    toggleSidebar() {
      this.$parent.toggleMobileMenu();
      this.navbarMinimize();
    },
  },
  components: {
    //MaterialInput,
  },
  computed: {
    ...mapState(["isRTL", "isAbsolute"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped>
.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: box-shadow 0.15s ease-in-out;
}

.navbar-toggler-icon {
  position: relative;
  width: 22px;
  height: 22px;
  display: block;
}

.navbar-toggler-bar {
  display: block;
  position: absolute;
  width: 100%;
  height: 2px;
  border-radius: 1px;
  background: #555;
  transition: all 0.2s;
  left: 0;
}

.navbar-toggler-bar.bar1 {
  top: 0;
}

.navbar-toggler-bar.bar2 {
  top: 8px;
}

.navbar-toggler-bar.bar3 {
  top: 16px;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-bar.bar1 {
  transform: rotate(45deg);
  transform-origin: 10% 10%;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-bar.bar2 {
  opacity: 0;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-bar.bar3 {
  transform: rotate(-45deg);
  transform-origin: 10% 90%;
}

@media (max-width: 991.98px) {
  .navbar-collapse {
    position: fixed;
    top: 0;
    left: 0;
    width: 260px;
    height: 100vh;
    background: white;
    padding: 1.5rem;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 1000;
  }

  .navbar-collapse.show {
    transform: translateX(0);
  }
}
</style>
